export function hideUselessActContainers() {
  $('div.hide_box').each((i, obj) => {
    let container = $(obj).parent().parent()
    container.addClass('h-50px')
    container.removeClass('textbook-activity-container')
  })
}
